<template>
  <CContainer>
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CModal
          backdrop="static"
          v-if="form.user_id"
          :visible="modal.isVisible.todayPasses"
          :close-on-backdrop="false"
          class="p-0"
          size="lg"
          add-content-classes="no-padding-modal no-border-radius-modal left-top-header"
        >
          <div class="pt-4 px-3 create-popup-header">
            <div
              class="d-inline-block bg-gradient-blue text-white rounded-circle p-1 lh-normal cursor-pointer"
              @click="closeModal()"
            >
              <span class="close-icon" />
            </div>
          </div>
          <div>
            <StudentPassHistory
              ref="phistory"
              :user-id="form.user_id.value.id"
            />
          </div>
          <template #footer-wrapper>
            <div />
          </template>
        </CModal>
        <div class="mb-2 max-w-400 m-auto">
          <CAlert
            v-if="
              reqResponse.message &&
              reqResponse.message !== 'The given data was invalid.'
            "
            class="mt-4"
            :color="reqResponse.type"
            :show="!!reqResponse.message"
          >
            {{ reqResponse.message }}
          </CAlert>
          <LazyLoadSelect
            :classes="[
              {
                'is-invalid':
                  v$.form.user_id.$error || reqResponse.errors.user_id
              },
              'mb-3'
            ]"
            :is-multiple="false"
            :selected="form.user_id"
            type="student"
            placeholder="Search students"
            tabindex="1"
            @changed="
              (value) => {
                form.user_id = value
              }
            "
          >
            <template #footer>
              <div
                v-if="v$.form.$error && v$.form.user_id.required.$invalid"
                class="invalid-feedback"
              >
                This field is required
              </div>
              <div v-if="reqResponse.errors.user_id" class="invalid-feedback">
                {{ reqResponse.errors.user_id[0] }}
              </div>
            </template>
          </LazyLoadSelect>
          <div
            v-if="form.user_id && userInfo && userInfo.polarity_active"
            class="d-flex align-items-center mb-3 text-danger"
          >
            The hall is currently busy for this student. Please see your
            building admin for any questions.
          </div>
          <div
            v-if="
              form.user_id &&
              userInfo &&
              userInfo.show_active_pass_limit_message
            "
            class="d-flex align-items-center mb-3 text-danger"
          >
            Active Pass Limit has been reached. By clicking submit, you will
            exceed the limit.
          </div>
          <div v-if="form.user_id" class="d-flex align-items-center mb-3">
            <div class="">
              Today's Passes:
              <span class="passes-count-badge ms-1" @click="showPassesModal">{{
                userInfo && userInfo.user_passes_count
              }}</span>
            </div>
            <div
              v-if="userInfo && userInfo.passes_remain"
              class="ms-2 user-passes-remain flex-1"
            >
              The student has {{ userInfo.passes_remain }} pass(es) remaining
              today.
            </div>
          </div>

          <p class="mb-0">Where do you want to send the student?</p>
          <div class="favorite-rooms-carousel p-0 m-0" tabindex="-1">
            <FavoriteCarousel
              :key="'destination'"
              :teacher="true"
              section="destination"
              :not-managable="true"
              classes="pb-0 pt-0 mt-2 smaller-size"
              :action="(elem) => getCapacityReached(elem)"
              :selected="form.to_id"
              :isvalid="v$.form.to_id.$error || reqResponse.errors.to_id"
              tabindex="-1"
            />
          </div>
          <LazyLoadSelect
            :class="[
              {
                'is-invalid':
                  v$.form.to_id.$error ||
                  reqResponse.errors.to_id ||
                  reqResponse.errors.to_type
              },
              'mb-3 mt-3'
            ]"
            :is-multiple="false"
            :selected="form.to_id"
            type="combined"
            placeholder="To:"
            tabindex="2"
            @changed="(elem) => getCapacityReached(elem)"
          >
            <template #footer>
              <div
                v-if="
                  form.to_id &&
                  form.to_id.value &&
                  form.to_id.value.unavailability
                "
                class="invalid-feedback d-flex flex-wrap font-weight-bold"
              >
                This adult is unavailable until
                <span
                  class="mx-1"
                  v-html="
                    $helpers.getHTMLDateTime(
                      form.to_id.value.unavailability.to_date,
                      'MMMM D, YYYY',
                      'h:mm A'
                    ) + '.'
                  "
                />
                <span v-if="form.to_id.value.unavailability.comment"
                  >Note: {{ form.to_id.value.unavailability.comment }}</span
                >
              </div>
              <div
                v-if="v$.form.$error && v$.form.to_id.required.$invalid"
                class="invalid-feedback"
              >
                This field is required
              </div>
              <div v-if="isCurrRoomRestricted" class="invalid-feedback">
                This location is restricted for this student. By clicking submit
                you will override this restriction.
              </div>
              <div v-if="reqResponse.errors.to_id" class="invalid-feedback">
                {{ reqResponse.errors.to_id[0] }}
              </div>
              <div v-if="reqResponse.errors.to_type" class="invalid-feedback">
                {{ reqResponse.errors.to_type[0] }}
              </div>
              <div v-if="toCapacityReached" class="invalid-feedback d-block">
                Maximum capacity for the location has been reached. By clicking
                submit you will exceed the max.
              </div>
            </template>
          </LazyLoadSelect>
          <div class="form-group">
            <textarea
              maxlength="250"
              v-model="form.comment"
              class="form-control"
              :class="{ 'is-invalid': reqResponse.errors.comment }"
              placeholder="Reason..."
              rows="4"
              tabindex="3"
            />
            <div class="text-end mt-1">250 characters max</div>
            <div v-if="reqResponse.errors.comment" class="invalid-feedback">
              {{ reqResponse.errors.comment[0] }}
            </div>
          </div>
          <div class="d-flex">
            <CCheckBox
              label="Pre-approve pass"
              v-model="form.auto_approve"
              class="custom-checkbox text-start"
              :custom="true"
              tabindex="4"
            />
          </div>
          <div
            v-if="isUserAllowTardy"
            class="tardy-late-pass d-flex flex-column mt-2"
          >
            <p class="mb-1">Mark this pass as:</p>
            <TardyRadioGroup v-model="form.tardy_badge" />
          </div>
          <div class="form-group form-actions mt-4 text-center">
            <div class="d-flex align-items-center justify-content-center">
              <div @click="submit()">
                <CLoadingButton
                  :spinner="isLoading"
                  :disabled="isLoading"
                  :loading="isLoading"
                  tabindex="5"
                  class="me-2 px-5 py-3 btn bg-gradient-blue text-white"
                >
                  Submit
                </CLoadingButton>
              </div>
              <router-link
                v-if="!isInView"
                class="text-graident-blue ms-3"
                to="/teacher-pass"
              >
                <div class="d-flex align-items-center" @click="goToFullMenu()">
                  <img
                    width="18"
                    class="m-0 me-2"
                    src="@/assets/images/icons/gradient-link.png"
                  />
                  <span class="text-graident-blue">Go to full menu</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
import StudentPassHistory from "@/components/DataTables/StudentPassHistory"
import FavoriteCarousel from "@/components/Forms/FavoriteCarousel"
import LazyLoadSelect from "@/components/LazyLoadSelect.vue"
import { mapGetters } from "vuex"
import TardyRadioGroup from "./TardyRadioGroup"

export default {
  name: "CreateTeacherPassForm",
  components: {
    StudentPassHistory,
    FavoriteCarousel,
    LazyLoadSelect,
    TardyRadioGroup
  },
  props: ["isInView"],
  emits: ["closeModal"],
  setup() {
    return { v$: useVuelidate() }
  },
  data: () => ({
    isLoading: false,
    form: {
      user_id: null,
      to_id: [],
      comment: "",
      auto_approve: true,
      tardy_badge: ""
    },
    reqResponse: {
      type: "",
      message: "",
      errors: {}
    },
    modal: {
      isVisible: {
        todayPasses: false
      }
    },
    userInfo: null,
    polarityMessage: null,
    isCapacityReached: false
  }),
  validations: {
    form: {
      user_id: {
        required
      },
      to_id: {
        required,
        isRestricted: (value, vm) => {
          if (vm.to_id && vm.to_id.value && !vm.to_id.value.isRestricted) {
            return true
          }
          return false
        }
      },
      auto_approve: {}
    }
  },
  watch: {
    "form.user_id"(val) {
      if (val && val.value) {
        this.userInfo = null
        this.$store
          .dispatch("proxyPasses/getProxyPassInfo", val.value.id)
          .then((res) => {
            this.userInfo = res
          })
      }
    }
  },
  created() {
    this.$store.dispatch("polarities/getPolarityMessage").then((res) => {
      if (res && res.data && res.data.data) {
        this.polarityMessage = res.data.data.message
          ? res.data.data.message
          : res.data.data.initial_default_value
      }
    })
  },
  computed: {
    ...mapGetters({
      currentUser: "authentication/user",
      tardyManagementOptions: "schools/tardyManagementOptions"
    }),
    isValid() {
      return !this.v$.form.$invalid
    },
    toCapacityReached() {
      return this.form && this.form.to_id && this.isCapacityReached
    },
    isCurrRoomRestricted() {
      return (
        this.userInfo &&
        this.form.to_id &&
        this.form.to_id.value &&
        this.userInfo.restricted_rooms &&
        this.userInfo.restricted_rooms.includes(this.form.to_id.value.id)
      )
    },
    activeDashboardSettings() {
      let current = localStorage.getItem("dashSettings")
      if (current) {
        current = JSON.parse(current)
        current.activePassState = "only_active"
        return false
      }
      return current
    },
    isUserAllowTardy() {
      if (this.tardyManagementOptions != null) {
        if (this.tardyManagementOptions.usage["within-ehp"]) {
          if (this.currentUser.role.name == "admin") {
            return true
          } else if (
            (this.currentUser.role.name == "staff" ||
              this.currentUser.role.name == "teacher") &&
            this.tardyManagementOptions["allow-teacher-staff"]
          ) {
            return true
          } else if (
            this.currentUser.allow_tardy &&
            this.tardyManagementOptions["allow-selected-users-only"]
          ) {
            return true
          }
          return false
        }
        return false
      }
      return false
    }
  },
  methods: {
    getCapacityReached(value) {
      this.form.to_id = value
      this.isCapacityReached = false
      if (value.value.type === "App\\Models\\Room") {
        this.$store
          .dispatch("rooms/getCapacityReached", value.value.id)
          .then((response) => {
            if (response.data) {
              const data = response.data.data
              //if limit is set to "-" the room is unlimited
              this.isCapacityReached =
                data.capacity_reached && data.limit != "-"
            }
          })
      }
      this.$store
        .dispatch("rooms/getUnavailability", {
          id: value.value.id,
          type: value.value.type
        })
        .then((response) => {
          if (response.data.data) {
            this.form.to_id.value.unavailability = response.data.data
          }
        })
    },
    submit() {
      this.resetResponseMessages()
      if (this.isValid) {
        const pass = {
          user_id: this.form.user_id.value.id,
          to_id: this.form.to_id.id
            ? this.form.to_id.id
            : this.form.to_id.value.id,
          to_type: this.form.to_id.type
            ? this.form.to_id.type
            : this.form.to_id.value.type,
          comment: this.form.comment,
          auto_approve: this.form.auto_approve,
          tardy_badge: this.form.tardy_badge
        }
        this.isLoading = true
        this.$store
          .dispatch("proxyPasses/createProxyPass", pass)
          .then(() => {
            setTimeout(() => {
              localStorage.removeItem("dashSettings")
              this.resetForm()
              this.isLoading = false
              this.$router.push("/dashboard")
              this.$emit("closeModal")
            }, 500)
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
            this.isLoading = false
          })
      } else {
        this.v$.$touch()
      }
    },
    resetForm() {
      this.v$.$reset()
      this.form = {
        user_id: null,
        to_id: [],
        comment: "",
        auto_approve: false,
        tardy_badge: ""
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    },
    showPassesModal() {
      this.modal.isVisible.todayPasses = true
      setTimeout(() => {
        this.$refs.phistory.getUserPasses(this.form.user_id.value.id)
      }, 200)
    },
    closeModal() {
      this.modal.isVisible.todayPasses = false
    },
    refreshForm() {
      this.resetForm()
      this.resetResponseMessages()
    },
    goToFullMenu() {
      this.$emit("closeModal")
    }
  }
}
</script>
